import AsyncStorage from '@react-native-async-storage/async-storage';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const generateClaimId = () => `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;

const CLAIM_TTL_MS = 7 * 24 * 60 * 60 * 1000;

type ClaimFunnelStore = {
    claimId: string | null;
    claimedAt: number | null;
    creditAwaitingUse: boolean;
    actions: {
        startClaim: () => void;
        setCreditAwaitingUse: (value: boolean) => void;
    };
};

export const useClaimFunnelStore = create<ClaimFunnelStore>()(
    persist(
        set => ({
            claimId: null,
            claimedAt: null,
            creditAwaitingUse: false,
            actions: {
                startClaim: () => set({ claimId: generateClaimId(), claimedAt: Date.now(), creditAwaitingUse: false }),
                setCreditAwaitingUse: value => set({ creditAwaitingUse: value }),
            },
        }),
        {
            name: 'claim-funnel-storage',
            storage: createJSONStorage(() => AsyncStorage),
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            partialize: ({ actions, ...rest }: ClaimFunnelStore) => rest,
        }
    )
);

export const getActiveClaim = () => {
    const { claimId, claimedAt, creditAwaitingUse } = useClaimFunnelStore.getState();
    if (!claimId || !claimedAt || Date.now() - claimedAt > CLAIM_TTL_MS) {
        return null;
    }
    return { claimId, creditAwaitingUse };
};
